import { Transformation } from './Transformation';

export class PlaceholderProcessor {
  constructor(private transforms: Transformation[]) {}

  run(str: string): string {
    for (const transfrom of this.transforms) {
      str = str.replaceAll(`{${transfrom.from}}`, transfrom.to);
    }
    return str;
  }
}
